module.exports = __webpack_public_path__ + "img/hizmet_saglayici.38e103b1.svg";